/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectAllRows } from '../../../../redux/MultiselectRows';
import { useSelector, useDispatch } from 'react-redux';

const ManageDeviceTemplateTable = ({ pageNumber, List, handleSearchParams, sortValue, setisSortSelected, setConfirmationState, setTextAreaMsg, setSelectedRow }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef();
    const selectedRows = useSelector((state) => state?.MultiSelectSlice?.selectedRows?.topCheckBox)
    const urlParams = new URLSearchParams(window.location.search);
    const dispatch = useDispatch()

    /* The `useOnClickOutside` hook is a custom hook that is used to detect when a user clicks outside
    of a specific element. In this case, it is used to detect when the user clicks outside of the
    `selectedRef` element. When the user clicks outside, the callback function `() => {
    setSelectedIndex(null) }` is executed, which sets the `selectedIndex` state to `null`. This is
    typically used to close or reset any open or active selections or pop-ups when the user clicks
    outside of them. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });


    // function renameKeyInArray(array, oldKey, newKey) {
    //     return array.map(obj => {
    //         if (obj.hasOwnProperty(oldKey)) {
    //             return { ...obj, [newKey]: obj[oldKey], [oldKey]: undefined };
    //         }
    //         return obj;
    //     });
    // }

    /**
    * The function `handleAllRowsSelect` is used to handle the event of selecting all rows in a table
    * and dispatches an action to select all rows.
    */
    const handleAllRowsSelect = (event) => {
        const paramstoPass = [event.target.checked, pageNumber.toString(), List.data]
        dispatch(selectAllRows(paramstoPass))
        
    }




    return (
        <div>
            <div className='2xl:h-[calc(100vh-215px)] h-[calc(100vh-226px)] devicetemplate  overflow-auto scrollbar_purple pb-2.5'>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                <div className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id={pageNumber} data-testid="checkbox" checked={selectedRows?.find(item => item.page_number === pageNumber.toString())?.isChecked ? true : false} onChange={handleAllRowsSelect} />
                                    <label htmlFor={pageNumber} className="text-sm font-normal text-[#031624] w-full cursor-pointer"></label>
                                </div>
                            </th>
                            <th id="id" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Template ID </span>
                            </th>
                            <th id="username" className="px-[18px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Template Name </span>
                            </th>
                            <th id="first" className="px-[18px] py-2 min-w-[140px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Manufacturer</span>
                            </th>
                            <th id="last" className="px-[18px] py-2 min-w-[120px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Model</span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[170px]">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Template Creator
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[195px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Creation Timestamp
                                </span>
                            </th>
                            <th className="px-[18px] py-2 min-w-[195px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Modified Timestamp
                                </span>
                            </th>
                            <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] min-w-[70px]">
                                <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Actions
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item, index) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                    setSelectedRow={setSelectedRow}
                                />
                            </Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ManageDeviceTemplateTable